import styled, { css } from "styled-components";
import { NavLink } from 'react-router-dom';
import { Color, Screen } from 'styles';

const DockedWrapperStyle = css`
  animation: fadeInFromNone 0.5s ease-out;
  border-bottom: 0;
  height: 65px;
  position: fixed;
  left: 0;
  top: 0;
  
  a.navLink {
    padding: 22px;
  }
  
  @keyframes fadeInFromNone {
    0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 1;
    }
  }
`;

const MediumWrapperStyle = css`
  height: 65px;
`;

export const StyledWrapper = styled.header`
  background-color: ${Color.Black};
  height: 126px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
  
  ${Screen.medium(MediumWrapperStyle)}
  ${props => props.isDocking ? DockedWrapperStyle : null}
`;

const MediumLogoStyle = css`
   margin-top: -28px;
   overflow: hidden;
   height: 116px;
   transform: scale(0.6);
   margin-left: -48px;

`;
export const StyledLogo = styled.h1`
  display: inline-block;
  
  ${props => props.isDocking ? MediumLogoStyle : null}
  ${Screen.medium(MediumLogoStyle)}
`;

const MediumNavStyle = css`
  align-items: center;
  background: ${Color.Black};
  display: ${props => props.isOpened ? 'flex' : 'none'};
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
`;

export const StyledNav = styled.nav`
  float: right;
  
  ${Screen.medium(MediumNavStyle)}
`;

const MediumNavListStyle = css`
  display: block;
  width: 100%
`;
export const StyledNavList = styled.ul`
  display: inline-block;
  list-style-type: none;
  padding: 0;
  margin: 0;
  
  ${Screen.medium(MediumNavListStyle)}
`;

const MediumNavItemStyle = css`
  display: block;
  width: 100%;
  
  a {
    &:hover {
     &:after {
      opacity: 0;
     }
  }
  }
`;

export const StyledNavItem = styled.li`
  display: inline-block;
  
  ${Screen.medium(MediumNavItemStyle)}
`;

const MediumNavLinkStyle = css`
  display: block;
  padding: 22px;
  text-align: center;
  width: 100%;
  
  &.active {
    background: ${Color.Orange};
  }
`;

export const StyledNavLink = styled(NavLink)`
  color: ${Color.White};
  display: inline-block;
  padding: 52px 22px;
  position: relative;
  
  &:after {
    background-color: ${Color.Orange};
    bottom: 1px;
    content: '';
    display: block;
    height: 2px;
    left: 0;
    opacity: 0;
    position: absolute;
    transition: opacity 300ms ease-in-out;
    width: 100%;
  }
  
  &:hover, &.active {
   &:after {
    opacity: 1;
   }
  }
  
  ${Screen.medium(MediumNavLinkStyle)}
`;

const MediumMenuButtonStyle = css`
  display: block;
  position: relative;
  margin-top: 23px;
  z-index: 10;
`;

export const StyledMenuButton = styled.div`
  display: none;
  float: right;
  margin-top: ${props => props.isDocking ? '23px' : '49px'};
  
  ${Screen.medium(MediumMenuButtonStyle)}
`;



// WEBPACK FOOTER //
// ./src/components/header/header.style.js